import React from 'react'
import PropTypes from 'prop-types'

const PriceOfferConversationTitle = ({ itemUrl, itemTitle }) => (
  <div>
    Price Offer for:
    <a href={itemUrl} className="u-ml10">{itemTitle}</a>
  </div>
)

PriceOfferConversationTitle.propTypes = {
  itemUrl: PropTypes.string.isRequired,
  itemTitle: PropTypes.string.isRequired,
}

export default PriceOfferConversationTitle
